import React, {useState} from 'react';
import {observer} from 'mobx-react-lite';
import ChevronIcon from '@svg/chevron.svg?react';
import {Toggle} from '@src/components/shared/toggle/toggle';
import {useStores} from '@src/components/store';
import {PresetDto} from '@src/dtos/preset.dto';
import {ServiceItemTooltip} from '@src/components/features/services/service-item-tooltip/service-item-tooltip';

export interface PresetItemProps {
    preset: PresetDto;
}

/** A single category group preset row with a toggle and an expandable categories list. */
export const PresetItem: React.FC<PresetItemProps> = observer(({preset}) => {
    const {fwVersionBronzeStore} = useStores();
    const [isExpanded, setIsExpanded] = useState(false);

    const isActive = fwVersionBronzeStore.activePresetId === preset.groupId;

    const isDisabled = !fwVersionBronzeStore.isSelectedBronzeVersionEditable
        || fwVersionBronzeStore.isDnsProtectionDeactivated;

    const disableReason = fwVersionBronzeStore.bronzeDomainsDisableReason;

    const handleToggle = () => {
        if (isActive) {
            fwVersionBronzeStore.deactivatePreset();
        } else {
            fwVersionBronzeStore.activatePreset(preset.groupId);
        }
    };

    return (
        <div className={`preset-item${isActive ? ' active' : ''}`}>
            <div className="preset-item__row">
                <div className="preset-item__info">
                    <span className="item-header">{preset.groupName}</span>
                    <span className="item-info">Block {preset.categories.length} categories</span>
                </div>
                <span className="service-item-tooltip-trigger">
                    <ServiceItemTooltip
                        title={preset.groupName}
                        descriptionList={[preset.groupDescription]}
                    />
                </span>
                <Toggle value={isActive} onChange={handleToggle}
                        disableReason={isDisabled ? disableReason : undefined}/>
                <ChevronIcon
                    className={`preset-item__chevron ${isExpanded ? 'expanded' : ''}`}
                    onClick={() => setIsExpanded(o => !o)}
                />
            </div>
            {isExpanded && (
                <ul className="preset-item__categories">
                    {preset.categories.map(category => (
                        <li key={category.categoryName} className="preset-item__category">
                            {category.categoryTitle ?? category.categoryName}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
});
